const DEFAULT_IPFS_GATEWAY = 'https://ipfs.io/ipfs/'

export function safeImageSrc(raw, failed = '') {
  const src = normalizeImageSrc(raw)
  if (!src || src === failed) return ''
  return src
}

export function imageFailedSrc(event, currentSrc = '') {
  return String(currentSrc || event?.currentTarget?.currentSrc || event?.currentTarget?.src || '').trim()
}

export function normalizeImageSrc(raw) {
  const src = String(raw || '').trim()
  if (!src) return ''
  if (src.startsWith('ipfs://')) return ipfsGatewayUrl(src.slice('ipfs://'.length))
  try {
    const origin = typeof window !== 'undefined' && window.location ? window.location.origin : 'http://localhost'
    const url = new URL(src, origin)
    if (url.hostname === 'ipfs.io' && url.pathname.startsWith('/ipfs/')) {
      return ipfsGatewayUrl(url.pathname.slice('/ipfs/'.length) + url.search + url.hash)
    }
  } catch {
    return ''
  }
  return src
}

function ipfsGatewayUrl(path) {
  const env = import.meta.env || {}
  const gateway = String(env.VITE_IPFS_GATEWAY_URL || env.IPFS_GATEWAY_URL || DEFAULT_IPFS_GATEWAY).trim() || DEFAULT_IPFS_GATEWAY
  const base = gateway.endsWith('/') ? gateway : `${gateway}/`
  return `${base}${String(path || '').replace(/^\/+/, '')}`
}
